module.exports = __webpack_public_path__ + "img/serving_400.bf1785a4.webp";